import { z } from 'zod';

const serverErrorSchema = z.object({
    errorCode: z.string(),
    message: z.string(),
});

export type ServerError = z.infer<typeof serverErrorSchema>;

export const apiErrorBodySchema = z.object({
    errors: serverErrorSchema.array(),
});

export type ApiErrorBody = z.infer<typeof apiErrorBodySchema>;

export const consentErrorSchema = apiErrorBodySchema.refine(({ errors }) =>
    errors.some(({ errorCode }) => errorCode === 'AUT0006'),
);

export const httpStatusCodeSchema = z.union([z.literal(400), z.literal(403), z.literal(404), z.literal(500)]);

export class ApiError extends Error {
    constructor(
        public readonly errors: readonly ServerError[] = [],
        public readonly status: number,
    ) {
        super();
    }
}
